import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../../services/analyticsService';

/**
 * Hook that tracks page views with Firebase Analytics
 * @param {string} screenName - Optional custom screen name. If not provided, uses pathname
 */
export const usePageTracking = (screenName) => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on mount and when location changes
    const pageName = screenName || location.pathname;
    analyticsService.trackScreenView(pageName);
  }, [location, screenName]);
};

export default usePageTracking;